/** Root-level tab paths that should NOT show a back button. */
const ROOT_PATHS = new Set(['/', '/home', '/recipes', '/meal-plans', '/login', '/settings', '/eating-style'])

/** Routes whose URL doesn't mirror where they sit in the app, so their parent can't be derived. */
const PARENT_OVERRIDES: [RegExp, string][] = [
  [/^\/meal\/[^/]+$/, '/recipes'],
  [/^\/cook\/[^/]+$/, '/meal-plans'],
  [/^\/add-recipe$/, '/recipes']
]

/**
 * Whether to show a back button in the mobile top bar for the given pathname.
 * Returns false for top-level tab destinations and focused task flows that
 * manage their own navigation (wizard, ingredient rule form).
 */
export function showMobileBackButton(pathname: string): boolean {
  if (ROOT_PATHS.has(pathname)) return false
  // Focused task flows with their own navigation chrome (wizard + embedded ingredient-rule form)
  if (pathname.includes('/food-profiles/create') || (pathname.includes('/food-profiles/') && pathname.includes('/edit'))) return false
  if (pathname.includes('/eating-style/eating-preferences')) return false
  return true
}

/** Where "up a level" goes from the given pathname: the path minus its last segment, or null at a root. */
export function parentPath(pathname: string): string | null {
  if (ROOT_PATHS.has(pathname)) return null
  const override = PARENT_OVERRIDES.find(([pattern]) => pattern.test(pathname))
  if (override) return override[1]
  return pathname.slice(0, pathname.lastIndexOf('/')) || '/home'
}
